import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import useFetchClasses from "../../hooks/useFetchClasses";
import useFetchSections from "../../hooks/useFetchSections";
import Select from "react-select";

import { ApiUrl } from "../../../ApiUrl";

const ModalConfirm = ({ show, handleClose, onSelectStudent }) => {
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [students, setStudents] = useState([]);
  const [studentLoading, setStudentLoading] = useState(false);
  const [studentError, setStudentError] = useState("");
  const {
    classes,
    loading: classLoading,
    error: classError,
  } = useFetchClasses();
  const [studentData, setStudentData] = useState([]);
  const [fullStudentData, setFullStudentData] = useState([]);
  const [filters, setFilters] = useState({
    studentName: "",
    admissionNo: "",
    barcode: "",
    classId: "",
    section: "",
    fatherName: "",
    motherName: "",
    schoolAdmissionNo: "",
  });

  // useEffect(() => {
  //   const fetchFullStudentData = async () => {
  //     try {
  //       const academicSessionId = localStorage.getItem("academicSessionId");
  //       if (!academicSessionId) {
  //         console.error("No academic session ID found in local storage");
  //         return;
  //       }
  //       const response = await fetch(
  //         `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetAllSTUDENTList/${academicSessionId}`
  //       );
  //       if (!response.ok) {
  //         throw new Error("Error fetching student data");
  //       }
  //       const data = await response.json();
  //       if (data.data) {
  //         setFullStudentData(data.data);
  //         setStudentData(data.data);
  //       } else {
  //         console.warn("No data found for the given academic session ID");
  //       }
  //     } catch (error) {
  //       console.error("Fetch error:", error);
  //     }
  //   };
  //   fetchFullStudentData();
  // }, []);

  // useEffect(() => {
  //   const fetchFullStudentData = async () => {
  //     try {
  //       const academicSessionId = localStorage.getItem("nextAcademicSessionId");
  //       if (!academicSessionId) {
  //         console.error("No academic session ID found in local storage");
  //         return;
  //       }

  //       const response = await fetch(
  //         `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetAllSTUDENTList/${academicSessionId}`
  //       );

  //       if (!response.ok) {
  //         throw new Error("Error fetching student data");
  //       }

  //       const data = await response.json();
  //       if (data.message === "success!!" && data.data) {
  //         setFullStudentData(data.data);
  //         setStudentData(data.data);
  //       } else {
  //         console.warn("No data found for the given academic session ID");
  //       }
  //     } catch (error) {
  //       console.error("Fetch error:", error);
  //     }
  //   };

  //   fetchFullStudentData();
  // }, []);



  const {
    sections,
    loading: sectionLoading,
    error: sectionError,
  } = useFetchSections(selectedClass);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchFullStudentData = async () => {
      try {
        const academicYearId = localStorage.getItem("academicSessionId");
        if (!academicYearId) {
          console.error("No academic year ID found in local storage");
          return;
        }

        const response = await fetch(
          `${ApiUrl.apiurl}STUDENT_CLASS/STUDENTCLASSConfirmRECORDFILTER/?academic_year_id=${academicYearId}`
        );

        if (!response.ok) {
          throw new Error("Error fetching student data");
        }

        const data = await response.json();
        if (data.message === "success!!" && data.data) {
          setFullStudentData(data.data);
          setStudentData(data.data);
        } else {
          console.warn("No data found for the given academic session ID");
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchFullStudentData();
  }, []);

  // old codes
  // const handleSearch = () => {
  //   const filteredData = fullStudentData.filter((student) => {
  //     // Destructure student properties directly
  //     const {
  //       studentname,
  //       school_admission_no,
  //       barcode,
  //       admission_no,
  //       classname,
  //       sectionname,
  //       fatherName,
  //       motherName,
  //     } = student;

  //     // Convert student name to lower case for comparison
  //     const fullName = studentname.toLowerCase();
  //     const searchParts = filters.studentName.toLowerCase().split(" ").filter(Boolean);

  //     // Check if all parts of the student name match
  //     const nameMatches = searchParts.every((part) => fullName.includes(part));

  //     return (
  //       // Apply filters based on the provided values in filters object
  //       (!filters.studentName || nameMatches) &&
  //       (!filters.admissionNo || school_admission_no.toString().includes(filters.admissionNo)) &&
  //       (!filters.barcode || barcode.toString().includes(filters.barcode)) &&
  //       (!filters.schoolAdmissionNo || admission_no.toString().includes(filters.schoolAdmissionNo)) &&
  //       (!filters.classId || classname.toLowerCase().includes(filters.classId.toLowerCase())) && // Fix for classname filter
  //       (!filters.section || sectionname.toLowerCase().includes(filters.section.toLowerCase())) && // Fix for sectionname filter
  //       (!filters.fatherName || fatherName.toLowerCase().includes(filters.fatherName.toLowerCase())) &&
  //       (!filters.motherName || motherName.toLowerCase().includes(filters.motherName.toLowerCase()))
  //     );
  //   });

  //   setStudentData(filteredData);
  // };

  //08202025
  const handleSearch = async () => {
    try {
      const academicYearId = localStorage.getItem("academicSessionId");
      if (!academicYearId) {
        console.error("No academic year ID found in local storage");
        return;
      }

      let url = `${ApiUrl.apiurl}STUDENT_CLASS/STUDENTCLASSConfirmRECORDFILTER/?academic_year_id=${academicYearId}`;

      // append filters
      if (filters.studentName) url += `&studentName=${filters.studentName}`;
      if (filters.admissionNo) url += `&admissionNo=${filters.admissionNo}`;
      if (filters.barcode) url += `&barcode=${filters.barcode}`;
      if (filters.schoolAdmissionNo) url += `&schoolAdmissionNo=${filters.schoolAdmissionNo}`;
      if (selectedClass) url += `&classId=${selectedClass}`;
      if (selectedSection) url += `&sectionId=${selectedSection}`;
      if (filters.fatherName) url += `&fatherName=${filters.fatherName}`;
      if (filters.motherName) url += `&motherName=${filters.motherName}`;

      const response = await fetch(url);
      if (!response.ok) throw new Error("Error fetching student data");

      const data = await response.json();
      if (data.message === "success!!" && data.data) {
        setFullStudentData(data.data);
        setStudentData(data.data);
      } else {
        setFullStudentData([]);
        setStudentData([]);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  const getClassName = (classId) => {
    const classObj = classes.find((cls) => cls.id === classId);
    return classObj ? classObj.classname : "N/A";
  };

  // const getSectionName = (sectionId) => {
  //   const sectionObj = sections.find((sec) => sec.id === sectionId);
  //   return sectionObj ? sectionObj.sectionname : "N/A";
  // };

  const getSectionName = (sectionId) => {
    const sectionObj = sections.find((sec) => sec.section_id === sectionId);
    return sectionObj ? sectionObj.sectionname : "N/A";
  };

  const handleSelectStudent = (student) => {
    const studentId = student.studentId; // Access the studentId directly

    // Store the selected studentId in localStorage
    localStorage.setItem("selectedClassConfirmStudentId", studentId);

    // Call the onSelectStudent callback passed from parent component
    onSelectStudent(student);

    // Close the modal after selection
    handleClose();
  };
  const handleClearFilters = () => {
    setFilters({
      studentName: "",
      admissionNo: "",
      barcode: "",
      classId: "",
      section: "",
      fatherName: "",
      motherName: "",
      schoolAdmissionNo: "",
    });
    setSelectedClass("");
    setSelectedSection("");
    setStudentData(fullStudentData);
  };

  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onClick={handleClose}></Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card p-0">
                <div className="card-body">
                  <p
                    style={{
                      marginBottom: "0px",
                      textAlign: "center",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    STUDENT SEARCH
                  </p>
                  <div className="row mb-2">
                    <div
                      className="col-12  d-flex
                      flex-wrap
                      gap-2"

                    // style={{ border: "1px solid #ccc" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary me-2"
                        style={{ width: "150px" }}
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary me-2"
                        style={{ width: "150px" }}
                        onClick={handleClearFilters}
                      >
                        Clear
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger me-2"
                        style={{ width: "150px" }}
                        onClick={handleClose}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                  {/* Search Fields */}
                  <div className="row mt-3">
                    <div className="col-12 col-md-3 mb-2">
                      <label className="form-label">Student Name</label>
                      <input
                        type="text"
                        name="studentName"
                        value={filters.studentName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Student Name"
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label className="form-label">Admission No</label>
                      <input
                        type="text"
                        name="admissionNo"
                        value={filters.admissionNo}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Admission No"
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label className="form-label">Student Barcode</label>
                      <input
                        type="text"
                        name="barcode"
                        value={filters.barcode}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Student Barcode"
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label className="form-label">Class</label>
                      <Select
                        options={classes.map((cls) => ({
                          label: cls.classname,
                          value: cls.id,
                        }))}
                        onChange={(selectedOption) =>
                          setSelectedClass(selectedOption?.value)
                        }
                        placeholder="Select Class"
                        value={
                          selectedClass
                            ? {
                              label: getClassName(selectedClass),
                              value: selectedClass,
                            }
                            : null
                        }
                      />
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-12 col-md-3 mb-2">
                      <label className="form-label">Section</label>
                      <Select
                        options={sections.map((sec) => ({
                          label: sec.sectionname,
                          value: sec.section_id,   // ✅ use section_id
                        }))}
                        onChange={(selectedOption) =>
                          setSelectedSection(selectedOption?.value)
                        }
                        placeholder="Select Section"
                        value={
                          selectedSection
                            ? {
                              label: getSectionName(selectedSection),
                              value: selectedSection,
                            }
                            : null
                        }
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label className="form-label">Father's Name</label>
                      <input
                        type="text"
                        name="fatherName"
                        value={filters.fatherName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Father's Name"
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label className="form-label">Mother's Name</label>
                      <input
                        type="text"
                        name="motherName"
                        value={filters.motherName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Mother's Name"
                      />
                    </div>
                  </div>

                  {/* Students Table */}
                  <div className="table-responsive mt-3">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Student Name</th>
                          <th>Admission No</th>
                          <th>Class</th>
                          <th>Section</th>
                          <th>Father Name</th>
                          <th>Mother Name</th>
                          <th>Student Barcode</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {studentData.map((student, index) => (
                          <tr key={index}>
                            <td>{student.studentname}</td>
                            <td>{student.admission_no}</td>
                            <td>{getClassName(student.classId)}</td>
                            <td>{student.sectionname}</td>
                            <td>{student.fatherName}</td>
                            <td>{student.motherName}</td>
                            <td>{student.barcode}</td>
                            <td>
                              <button
                                className="btn btn-success"
                                onClick={() => handleSelectStudent(student)}
                              >
                                Select
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalConfirm;
